var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlueWarning = function SvgBlueWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68.607,
    height: 60.055,
    viewBox: "0 0 68.607 60.055",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Warning_911852",
    transform: "translate(214.997 185.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17741",
    "data-name": "Group 17741",
    transform: "translate(-214.997 -185.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17740",
    "data-name": "Group 17740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M34.313,0a5.181,5.181,0,0,0-4.476,2.576L.719,52.271a5.1,5.1,0,0,0,0,5.208,5.167,5.167,0,0,0,4.5,2.576H63.4a5.18,5.18,0,0,0,4.5-7.783L38.789,2.576A5.181,5.181,0,0,0,34.313,0Zm0,3.164a2.253,2.253,0,0,1,1.8,1.008L65.227,53.9a2.055,2.055,0,0,1,0,1.96A2.331,2.331,0,0,1,63.4,56.891H5.222A2.289,2.289,0,0,1,3.4,55.855a2.055,2.055,0,0,1,0-1.96L32.517,4.172A2.253,2.253,0,0,1,34.313,3.164Zm0,13.439a1.579,1.579,0,0,0-1.575,1.568V40.288a1.585,1.585,0,0,0,1.575,1.6,1.562,1.562,0,0,0,1.547-1.6V18.17A1.555,1.555,0,0,0,34.313,16.6Zm0,28.445A2.366,2.366,0,1,0,36.634,47.4,2.333,2.333,0,0,0,34.313,45.048Z",
    transform: "translate(-0.004 0)",
    fill: "#07a3c8"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlueWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blueWarning.fa6e9aaa.svg";
export { ForwardRef as ReactComponent };